__turbopack_context__.v({
  "divider": "side-nav-divider-module__ACTuXW__divider",
});
